import type { ReactNode } from 'react';
import { AppCard, AppDisclosureGlyph, AppPanelButton, AppText } from '../../ui-foundation';

export default function SectionAccordionCard({
  emoji,
  title,
  subtitle: _subtitle,
  open,
  onToggle,
  children,
}: {
  emoji: string;
  title: string;
  subtitle: string;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
}) {
  return (
    <AppCard surface="secondary" gap={0} className="overflow-hidden">
      <AppPanelButton
        onClick={onToggle}
        className="rounded-2xl border-0 bg-transparent px-0 py-0 hover:bg-transparent"
      >
        <div className="flex w-full items-start gap-3 px-1 py-1 text-left">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-lg">
            <span aria-hidden="true">{emoji}</span>
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex min-w-0 items-center justify-between gap-3">
              <AppText className="min-w-0 flex-1" fontSize="$sm" fontWeight="700">{title}</AppText>
              <AppDisclosureGlyph open={open} />
            </div>
          </div>
        </div>
      </AppPanelButton>
      {open ? <div className="px-1 pb-1 pt-3">{children}</div> : null}
    </AppCard>
  );
}
